import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, mergeMap } from "rxjs/operators";
import { OrgModel } from "src/app/store/storeModels/user.model";
import { Endpoints } from "../shared/config/endpoints";
import { AppState } from "../store/app.state";

// import { OrganizationModel } from '../models/Organization.model';
@Injectable({
  providedIn: "root",
})
export class OrganizationService {
  private url = this.endpoints.signUpEndpoint;
  private salesClientApi = this.endpoints.leadsCompaniesContactClientsEndpoint;
  private org: OrgModel;
  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.org = info.organization;
    });
  }

  // Handle Errors
  private handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    return of(null);
  };

  // Merge Endpoints
  private get createOrganizationUrl() {
    return (
      this.endpoints.organizationEndpoint +
      this.endpoints.organization.createOrg
    );
  }
  private get getAllOrganizationUrl() {
    return (
      this.endpoints.organizationEndpoint +
      this.endpoints.organization.getAllOrg
    );
  }

  private get getOrganizationUsersUrl() {
    return (
      this.endpoints.organizationEndpoint +
      "/" +
      this.org.id +
      this.endpoints.organization.getUerByOrg
    );
  }

  // private get getOneOrganizationUrl() {
  //   return (
  //     this.endpoints.organizationEndpoint +
  //     this.endpoints.organization.getOneSubscription
  //   );
  // }
  // private get updateOrganizationUrl() {
  //   return (
  //     this.endpoints.organizationEndpoint +
  //     this.endpoints.organization.updateSubscription
  //   );
  // }
  private get deleteOrganizationUrl() {
    return (
      this.endpoints.organizationEndpoint +
      this.endpoints.organization.deleteOrg
    );
  }

  // Organization Creation
  // OrganizationModel
  registerOrganization(payload) {
    const body = {
      ...payload,
    };
    return this.http.post(this.url + "/newOrganization", body);
  }

  addSalesStat() {
    return this.http.post(this.salesClientApi + "/sales-stats", {});
  }

  createDefaultClientTemplates() {
    const data = {
      invoiceTemplateId: 2,
      quotationTemplateId: 1,
    };
    return this.http.post(`${this.salesClientApi}/templates`, data);
  }

  getAllOrganization() {
    try {
      return this.http
        .get(this.getAllOrganizationUrl)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }



  deleteOrganization(id) {
    try {
      return this.http
        .delete(`${this.deleteOrganizationUrl}/${id}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getUsersInOrganization(type = 5) {
    const url = `${this.url}/getOrganizationPersons/${this.org.id}/${type}`;
    return this.http.get(url).pipe(mergeMap((data: any[]) => {
      const result = data.map(dat => ({ ...dat.user, fullName: `${dat.user.firstName} ${dat.user.lastName}`, relationship:dat.userRel }))
      return of(result)
    }));
  }


  getOrganizationPersons(type: number) {
    return this.http.get(
      this.url + `/getOrganizationPersons/${this.org.id}/${type}`
    );
  }

  getPendingUsersInOrganization() {
    return this.http.get(
      this.url + `/getPendingUsersInOrganization/${this.org.id}`
    );
  }

  getUserById(id) {
    return this.http.get(this.url + `/getUser/${id}`);
  }

  getCurrency() {
    return this.http.get(this.url + `/getCurrencies`);
  }

  newOrgCurrency(payload) {
    try {
      return this.http
        .post(this.url + `/newOrgCurrency`, payload)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getOrgCurrencies() {
    return this.http.get(this.url + `/${this.org.id}/getOrgCurrencies/`);
  }

  getOrgOtherCurrencies() {
    return this.http.get(this.url + `/${this.org.id}/getOrgOtherCurrencies`);
  }


  // Demo Account

  createDemoOrg(orgID, teamID, userID,) {
    try {
      return this.http
        .get(`https://api-demo.notchcx.io/signup/${orgID}/${teamID}/${userID}/requestDemo`)
        .pipe(catchError(this.handleError)).toPromise();
    } catch (error) {
      alert(error);
    }
  }

  getOrganizationDemoDBStatus(orgId) {
    try {
      return this.http
        .get(`https://api-demo.notchcx.io/signup/${orgId}/getDataCounts
`)
        .pipe(catchError(this.handleError)).toPromise();
    } catch (error) {
      alert(error);
    }
  }

  createDummyData(orgID, teamID, userID) {
    try {
      return this.http
        .get(`https://api-demo.notchcx.io/settingsservice-notch-crm/${orgID}/${teamID}/${userID}/addDummy`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getUsersInOrganizationInternalResponse(type = 5, orgId) {
    const url = `${this.url}/getOrganizationPersons/${orgId}/${type}`;
    return this.http.get(url).pipe(mergeMap((data: any[]) => {
      const result = data.map(dat => ({ ...dat.user, fullName: `${dat.user.firstName} ${dat.user.lastName}`, relationship:dat.userRel }))
      return of(result)
    }));
  }
}
